__turbopack_context__.v({
  "dot": "TimeClockWidget-module-scss-module__n5DKda__dot",
  "dotPaused": "TimeClockWidget-module-scss-module__n5DKda__dotPaused",
  "dragRing": "TimeClockWidget-module-scss-module__n5DKda__dragRing",
  "pill": "TimeClockWidget-module-scss-module__n5DKda__pill",
  "pillBody": "TimeClockWidget-module-scss-module__n5DKda__pillBody",
  "pillBodyPaused": "TimeClockWidget-module-scss-module__n5DKda__pillBodyPaused",
  "timeclock-pulse": "TimeClockWidget-module-scss-module__n5DKda__timeclock-pulse",
});
